function About() {
  return (
    <section className="wf-section">
      <div className="wf-container wf-about">
        <img src="/images/DF.png" alt="Daniel Filion" className="wf-about-image" />
        <div>
          <div className="wf-tag">[ About ]</div>
          <h2>About Me</h2>
          <p>Hi, I'm Daniel, a solopreneur and software developer with close to 30 years of experience. I build software products and write fantasy books.</p>
        </div>
      </div>
    </section>
  );
}

export default About;
